"use client";

import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { SideDialog, SquareButton, useModal } from "@tosize/ui";
import { Fragment, type PropsWithChildren, type ReactNode } from "react";
import { usePathnameChange } from "~/hooks/useRouteChange";

interface MenuButtonProps extends PropsWithChildren {
	title: string;
	logo: ReactNode;
	variant?: "default" | "light";
}

export function MenuButton(props: MenuButtonProps) {
	const dialog = useModal();

	usePathnameChange(dialog.close);

	return (
		<Fragment>
			<SquareButton
				onClick={dialog.toggle}
				title={props.title}
				icon={faBars}
				component="button"
				size="medium"
				color={props.variant === "light" ? "shades-light" : "shades"}
			/>

			<SideDialog
				className="h-full"
				color={props.variant === "light" ? "white" : "shades-light"}
				size="md"
				position="left"
				title={props.logo}
				{...dialog.props}
			>
				{props.children}
			</SideDialog>
		</Fragment>
	);
}
